import { BaseConfig } from '../ServiceConfig';

export const OPERATION_FLOW_BASIC = 'basic';
export const OPERATION_FLOW_SELF = 'self';

export const TRANSACTION_SORT_TYPE_ASC = 'asc';
export const TRANSACTION_SORT_TYPE_DESC = 'desc';

export interface PaymentControllerUIConfig {
  logo: string;
}

export interface PaymentControllerConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PaymentControllerServiceConfigData';
  appFlow: string;
  processingOrder: string;
  transactionTtlSeconds: string;
  isProduction: boolean;
  uiConfig: PaymentControllerUIConfig;
}

export const PaymentControllerConfigurationFields: (keyof PaymentControllerConfiguration)[] = [
  'appFlow',
  'isProduction',
  'uiConfig',
  'processingOrder',
  'transactionTtlSeconds',
];

export const BlankPaymentControllerConfiguration: PaymentControllerConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PaymentControllerServiceConfigData',
} as PaymentControllerConfiguration;
